import apolloClient from '../../../apollo'
class BaseProvider {

    ping(){
        return apolloClient.query({
            query: require('./gql/ping.graphql')
        })
    }

    pingTimeout(){
        return apolloClient.query({
            query: require('./gql/pingTimeout.graphql')
        })
    }

    fetchGoogleMaterialIcons(){
        return apolloClient.query({
            query: require('./gql/fetchGoogleMaterialIcons.graphql')
        })
    }
}
const baseProvider = new BaseProvider()
export default baseProvider
